import styles from './round-button.module.scss';
import cn from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  theme?: 'primary' | 'clear' | 'grayish' | 'disabled';
  mobileSize?: 'mbSmall' | 'mbMedium' | 'mbLarge';
  desktopSize?: 'dsSmall' | 'dsMedium' | 'dsLarge';
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const RoundButton = ({
  className,
  children,
  theme,
  mobileSize,
  desktopSize,
  ...buttonAttr
}: Props) => {
  return (
    <button
      className={cn(
        styles.roundButton,
        className,
        theme && styles[theme],
        mobileSize && styles[mobileSize],
        desktopSize && styles[desktopSize],
      )}
      data-nagish="yad1-round-button"
      {...buttonAttr}
    >
      {children}
    </button>
  );
};
